import { render, staticRenderFns } from "./OtherMenuComponent.vue?vue&type=template&id=e3725d96&scoped=true&"
import script from "./OtherMenuComponent.vue?vue&type=script&lang=js&"
export * from "./OtherMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./OtherMenuComponent.vue?vue&type=style&index=0&id=e3725d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3725d96",
  null
  
)

export default component.exports